<template>
  <div class="vessel-course-unknown-icon" :style="cssVars">
    <vessel-course-unknown-safe v-if="isSafe" />
    <vessel-course-unknown-caution v-else-if="isCaution" />
    <vessel-course-unknown-danger v-else />
  </div>
</template>

<script>
import VesselCourseUnknownSafe from "./VesselCourseUnknownSafe.vue";
import VesselCourseUnknownCaution from "./VesselCourseUnknownCaution.vue";
import VesselCourseUnknownDanger from "./VesselCourseUnknownDanger.vue";
import C from "../../../Constants";
const { CAUTION, DANGER, SAFE } = C.RG_RISK_LEVEL;

export default {
  name: "VesselCourseUnknownIcon",
  components: {
    VesselCourseUnknownSafe,
    VesselCourseUnknownCaution,
    VesselCourseUnknownDanger,
  },
  props: {
    riskLevel: {
      type: Number, // SAFE(0) | CAUTION(3) | DANGER(8)
      default: CAUTION,
    }, // 色の切り替え
    hasManualAssessment: {
      type: Boolean,
      default: false,
    }, // 枠の表示非表示を切り替え
  },
  computed: {
    isSafe() {
      return this.riskLevel === SAFE;
    },
    isCaution() {
      return this.riskLevel === CAUTION;
    },
    isDanger() {
      return this.riskLevel === DANGER;
    },
    cssVars() {
      const autoCognitionFrameDisplay = this.hasManualAssessment
        ? "none"
        : "block";
      return {
        "--auto-cognition-frame-display": autoCognitionFrameDisplay,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.vessel-course-unknown-icon {
  --auto-cognition-frame-display: block;
  ::v-deep .auto-cognition-frame {
    display: var(--auto-cognition-frame-display);
  }
}
</style>
